// extracted by mini-css-extract-plugin
export var pageContainer = "_w-1";
export var settingsContent = "_w-0";